import { FC } from 'react';

import magnifyingGlass from 'assets/brand/mag-glass.png';
import notepadPng from 'assets/brand/notepad.png';
import Button from 'components/_core/Button';
import WorkListEmptyView from 'features/Work/components/WorkListEmptyView';

import locales from './locales';

interface EmptyViewProps {
  onClearSearch: () => void;
  isSearchResult: boolean;
}

const EmptyView: FC<EmptyViewProps> = ({ isSearchResult, onClearSearch }) => (
  <WorkListEmptyView
    description={isSearchResult ? undefined : locales.noItemsDescription}
    imageSrc={isSearchResult ? magnifyingGlass : notepadPng}
    title={isSearchResult ? locales.noResult : locales.noItems}
  >
    {isSearchResult ? (
      <Button
        icon="arrow-right"
        marginTop="space-14"
        onClick={onClearSearch}
        variant="inline-primary"
      >
        {locales.reset}
      </Button>
    ) : null}
  </WorkListEmptyView>
);

export default EmptyView;
